import React, { useState } from "react";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Form,
  Input,
  Col,
} from "reactstrap";

import { resetPassword } from "network/ApiAxios";
import Logo from "components/Logo";
import AuthFooter from "components/Footers/AuthFooter";
import AuthAnimation from "./AuthAnimation";
import { ROUTES } from "core/links";

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError("Email is required.");
      return;
    }
    const data = await resetPassword(email);
    if (data.success) {
      setError("");
    } else {
      setError(data.message);
    }
  };

  return (
    <>
      <Col xl="4" lg="5" md="7" className="d-flex flex-column mx-lg-0 mx-auto">
        <Logo />
        <Card className="card-plain">
          <CardHeader className="pb-0 text-start">
            <h4 className="font-weight-bolder">Reset Password</h4>
            <p className="mb-0">You will receive an e-mail shortly!</p>
          </CardHeader>
          <CardBody>
            <Form role="form" onSubmit={handlePasswordReset}>
              <FormGroup className="mb-3">
                <Input
                  className="form-control-lg"
                  name="email"
                  placeholder="Email"
                  type="email"
                  autoComplete="new-email"
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </FormGroup>

              {error && (
                <div className="text-muted font-italic">
                  <small>
                    <span className="text-danger fw-700">{error}</span>
                  </small>
                </div>
              )}
              <div className="text-center">
                <Button type="submit" className="btn-lg btn-custom btn-lg w-100 mt-4 mb-0" color="custom">
                  Send
                </Button>
              </div>
            </Form>
          </CardBody>
          <CardFooter className="text-center pt-0 px-lg-2 px-1">
            <p className="mb-2 text-sm mx-auto">
              Already have an account?
              <a href={ROUTES.LOGIN} className="text-primary text-gradient font-weight-bold"> Login here</a>
            </p>
            <p className="mb-2 text-sm mx-auto">
              Don't have an account?
              <a href={ROUTES.REGISTER} className="text-primary text-gradient font-weight-bold"> Sign up</a>
            </p>
          </CardFooter>
        </Card>
        <AuthFooter />
      </Col>


      <div className="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-left flex-column">
        <div className="position-relative bg-gradient-dark h-100 m-3 border-radius-lg d-flex flex-column overflow-hidden" >
          <span className="mask bg-gradient-dark opacity-6" ></span>
          <AuthAnimation />
        </div >
      </div >
    </>
  );
};

export default ResetPassword;
